<template>
  <User :project="vid" embed data-testid="user-component"></User>
</template>

<script>
import User from '../../../flux/views/UsersNew.vue';

export default {
  name: 'financialclose_varienceanalysis_user',
  // props: ['props'],
  data: function () {
    return {
      vid: "",
    }
  },
  components: {
    User
  },
  created() {
    this.vid = localStorage.getItem("VarianceAnalysis_id");
  },
  activated() {
    this.vid = localStorage.getItem("VarianceAnalysis_id");
  },

  methods: {
    refreshData() {
    },

  },
  computed: {
  },
  watch: {
  }
}
</script>

